import ReportList from './ReportList'

const ReportingView = () => {
	return (
		<div>
			<ReportList />
		</div>
	)
}

export default ReportingView
